import { render, staticRenderFns } from "./AlgorithmSelection.vue?vue&type=template&id=5d508e82&"
import script from "./AlgorithmSelection.vue?vue&type=script&lang=js&"
export * from "./AlgorithmSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports